import React from "react";
import { Helmet } from "react-helmet-async";

import Sidenav from "../components/Sidenav";
import "../Console.css";

const Ads = ({ domain }) => {
  return (
    <>
      <Helmet>
        <title>Banner Ads | BLEEP</title>
        <meta
          name="description"
          content="Introducing BLEEP, the revolutionary crowdsourcing app designed to combat counterfeit products and services."
        />
      </Helmet>

      <div className="d-flex">
        <Sidenav domain={domain} />

        <div
          style={{
            flex: 1,
            height: "calc(100vh - 94px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {/* Header */}
          <header
            style={{
              position: "relative",
              paddingInline: "30px",
              paddingBlock: "30px",
              color: "#fff",
              background:
                "linear-gradient(135deg, rgba(255,81,0,1) 0%, rgba(255,0,0,1) 100%)",
              overflow: "hidden",
            }}
          >
            <div
              aria-hidden
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: "url('/images/background-art.jpg')",
                backgroundRepeat: "repeat",
                backgroundSize: "400px 400px",
                backgroundPosition: "center",
                mixBlendMode: "overlay",
                opacity: 0.1,
                zIndex: 0,
                pointerEvents: "none",
              }}
            />
            <div
              className="row d-flex align-items-center"
              style={{ position: "relative", zIndex: 1 }}
            >
              <div className="col" style={{ padding: 10 }}>
                <b style={{ fontSize: "28px", textShadow: "#1c1c1c 1px 2px 0px" }}>
                  <i className="fa-solid fa-ad" /> Banner Ads
                </b>
                <p style={{ paddingTop: 8, textShadow: "#1c1c1c 1px 1px 0px", marginBottom: 0 }}>
                  Manage banner ads
                </p>
              </div>
            </div>
          </header>
        </div>
      </div>
    </>
  );
};

export default Ads;
